/* eslint-disable max-classes-per-file */
import type { Context, Contexts } from '@sentry/core'
import { captureException } from '@sentry/react'
import { isArray } from 'lodash-es'
import type { GQLErrorData, GQLResponse } from '~/types'
import { isError as isGQlError } from '~/utils'

function isError(item: unknown): item is Error {
	return typeof (item as Error)?.message === 'string'
}

export function captureError(error: AukError) {
	captureException(error, {
		contexts: error.contexts
	})
}

export class AukError extends Error {
	public contexts: Contexts
	public error?: Error | unknown

	constructor(message: string, error?: unknown, contexts: Contexts = {}) {
		super(message)
		this.name = 'AukError'
		this.message = message
		if (isError(error)) this.message += `: ${error.message}`
		this.error = error
		this.contexts = {
			error: (isError(error) ? error : {}) as Context,
			...contexts
		}
	}
}

export class GQLError extends AukError {
	// TODO: Add support for multiple GQLErrorData?
	constructor(error: GQLErrorData | GQLErrorData[]) {
		super(
			(isArray(error) ? error[0]?.message : error.message) ?? 'Unknown Error',
			undefined,
			isArray(error) ? { errors: { ...error } } : { error: { ...error } }
		)
		this.name = 'GQLError'
	}
}

export class CartError<T> extends GQLError {
	constructor(message: string, res: GQLResponse<T>) {
		// eslint-disable-next-line prefer-object-spread
		super(isGQlError(res) ? res.errors : [{ message }])
		this.name = 'CartError'
		this.message = message
	}
}
